module.exports = __webpack_public_path__ + "static/Corprate_Careers_03-8be9364fd89098b16298f0088023e4fb.jpg";